import { Modal } from "antd";
import DoctorForm from "../../components/pages/Doctors/DoctorForm";

const DoctorModal = ({ isOpen, onClose, doctorId, doctor }) => {
    const mode = doctorId ? "update" : "add";

    return (
        <Modal
            // title={mode === "add" ? "Add Doctor" : "Update Doctor"}
            open={isOpen}
            onCancel={onClose}
            footer={null}
            destroyOnHidden
            width={900}
        >
            <DoctorForm
                mode={mode}
                doctor={doctor}
                onSuccess={onClose}
            />
        </Modal>
    );
};

export default DoctorModal;

